<template>
  <div class="feedback-group">
    <div class="feedback-item">
      <div
        class="feedback-avatar"
        :style="{
          background: newestFeedback.color || '#6A1EBB'
        }"
      >
        <span v-if="!newestFeedback.isAnonymous && newestFeedback.emoji">
          {{ newestFeedback.emoji }}
        </span>
        <span v-else-if="!newestFeedback.isAnonymous && newestFeedback.name" class="leading-normal">
          {{ newestFeedback.name[0] }}
        </span>
        <font-awesome-icon v-else icon="user" size="sm" />
      </div>
      <div
        class="feedback-msg-box bg-secondary-15 p-3"
      >
        <div class="">
          <div class="flex justify-between">
            <div class="font-bold text-sm pr-1">
              {{ !newestFeedback.isAnonymous && newestFeedback.name ? newestFeedback.name : 'Anonymous' }}
            </div>
            <AhaStarRatingView
              v-if="newestFeedback.rating > 0"
              class="flex items-center flex-shrink-0"
              :rate="newestFeedback.rating"
              size="12px"
            />
          </div>
          <div
            v-if="!newestFeedback.isAnonymous && newestFeedback.email"
            class="text-base-80 text-xs mt-1"
          >
            {{ newestFeedback.email }}
          </div>
          <div
            v-if="newestFeedback.comment"
            class="mt-3 text-sm break-words"
          >
            {{ newestFeedback.comment }}
          </div>
          <div
            v-if="newestFeedback.updatedAt"
            class="mt-3 text-base-80 text-xs"
          >
            {{ formatDate(newestFeedback.updatedAt) }}
          </div>
        </div>
        <div
          v-if="olderFeedbacksLength"
          ref="feedbackExpandRef"
          class="feedback-expand mt-3"
        >
          <div
            class="feedback-expand-anchor"
          >
            <span
              class="cursor-pointer"
              @click="expandFeedbackGroup"
            >
              {{ $i18nPresenter.t('x more', { number: olderFeedbacksLength }) }}
            </span>
          </div>
          <div
            v-for="(feedback, index) in olderFeedbacks"
            :key="index"
            class="feedback-expand-wrapper"
          >
            <div
              v-if="feedback.comment"
              class="text-sm break-words"
            >
              {{ feedback.comment }}
            </div>
            <div
              v-if="feedback.updatedAt"
              class="mt-3 text-base-80 text-xs"
            >
              {{ formatDate(feedback.updatedAt) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    feedbackGroup: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      newestFeedback: {},
      olderFeedbacks: [],
    }
  },
  computed: {
    olderFeedbacksLength() {
      return this.olderFeedbacks && this.olderFeedbacks.length
    },
  },
  watch: {
    feedbackGroup: {
      handler(value) {
        if (value && value.length) {
          const [newest, ...older] = value
          this.newestFeedback = { ...newest }
          this.olderFeedbacks = older.filter((item) => item.comment)
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatDate(timeStamp) {
      return moment(timeStamp).format('DD/MM/YY - HH:mm')
    },
    expandFeedbackGroup() {
      const { feedbackExpandRef } = this.$refs

      if (feedbackExpandRef) {
        feedbackExpandRef.classList.add('show')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback-group {
  & + & {
    @apply mt-2;
  }
}

.feedback-item {
  @apply flex relative text-base;
}

.feedback-avatar {
  @apply flex flex-shrink-0 items-center justify-center text-base-0;
  @apply mr-3;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #6A1EBB;
  border: 1px solid #fff;
  text-transform: uppercase;
  font-weight: bold;

  i {
    color: #fff;
  }
}

.feedback-msg-box {
  flex-grow: 1;
  border-radius: 8px;
  color: #000;
}

.feedback-expand {
  &-anchor {
    @apply text-primary-90 text-sm border-t border-secondary-20 pt-3;
  }

  &-wrapper {
    @apply border-t border-secondary-20 pt-3 mt-3;
    display: none;
  }

  &.show {
    .feedback-expand-anchor {
      display: none;
    }

    .feedback-expand-wrapper {
      display: block;
    }
  }
}
</style>
